import filterItems from './filterItems';
import openModal from './openModal';

export default (filterData) => (dispatch) => {
    dispatch(filterItems(filterData));
    dispatch(openModal(false));
};
